const gtmManager = {
  install(Vue, options = {}) {

    Vue.prototype.$analytics = {
      pushEvent: function (action, value="") {
        window.dataLayer = window.dataLayer || [];

        let state = {
          'event': 'form',
          'action': action,
          'context': options.context
        };

        if (value) {
          state['value'] = value;
        }

        dataLayer.push(state);
      }
    };
  }
};

export { gtmManager };